// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contactIcons-module--wrapper--1bjg8","icon":"contactIcons-module--icon--OL9qM"};